import React, { useState, useEffect } from "react";
import { Card, CardContent } from "./ui/card";
import {
  Upload,
  ArrowRight,
  ArrowLeft,
  Link,
  Check,
  Loader,
  AlertCircle,
} from "lucide-react";
import { useAuth } from "../hooks/useAuth";
import insurancePolicyService from "../lib/InsurancePolicyService";
import InsurancePoliciesView from "./InsurancePoliciesView";
import DocumentPreviewModal from "./DocumentPreviewModal";

const InsurancePolicyUploader = ({ onUpload, onSync, onComplete, onBack }) => {
  const { user, getIdToken } = useAuth(); // Get the authenticated user from Firebase
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [existingPolicy, setExistingPolicy] = useState(null);
  const [existingPolicies, setExistingPolicies] = useState([]);
  const [policyType, setPolicyType] = useState(null); // 'manual' or 'connected'
  const [openPreviewModal, setOpenPreviewModal] = useState(false);

  // Reusable back button component
  const renderBackButton = () => {
    if (!onBack) return null;

    return (
      <button
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft className="w-4 h-4 mr-1" />
        Back
      </button>
    );
  };

  useEffect(() => {
    // Check if user has existing policies
    const fetchPolicies = async () => {
      try {
        if (!user || !user.uid) {
          setError("User authentication required");
          setLoading(false);
          return;
        }

        setLoading(true);
        setError(null);
        const token = await getIdToken();

        // Use the policy service to check for existing policies
        const result = await insurancePolicyService.checkExistingPolicies(
          token
        );
        if (result) {
          //setExistingPolicy(result.policy);
          //setPolicyType(result.type);
          setExistingPolicies(result);
          if (result && result.length > 0) {
            setExistingPolicy(result[0]);
          }
        }

        setLoading(false);
      } catch (err) {
        console.error("Error checking existing policies:", err);
        setError("Unable to check for existing policies. Please try again.");
        setLoading(false);
      } finally {
      }
    };

    // Fetch policies when component mounts or user changes
    fetchPolicies();
  }, [user]);

  const handleProceed = () => {
    if (
      onComplete &&
      (existingPolicy || (existingPolicies && existingPolicies.length > 0))
    ) {
      //onComplete(existingPolicy);
      onComplete();
    }
  };

  // If still loading
  if (loading) {
    return (
      <div className="space-y-6 p-4">
        {/* {renderBackButton()} */}

        <div className="text-center space-y-4">
          <h1 className="text-xl uppercase font-bold">
            Checking Insurance Status
          </h1>
          <p className="text-center text-darkGrey !mt-6">
            This should only take a moment
          </p>
          <div className="flex flex-col items-center justify-center p-8">
            <div className="flex items-center justify-center w-24 h-24 relative">
              <div className="absolute inset-0 flex items-center justify-center">
                <svg
                  className="w-full h-full animate-spin"
                  viewBox="0 0 100 100"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    stroke="#EAE7E7"
                    strokeWidth="13"
                    fill="none"
                  />
                  <path
                    d="M90,50 A40,40 0 0,0 50,10"
                    stroke="#7B61FF"
                    strokeWidth="13"
                    fill="none"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <Loader className="w-8 h-8 text-[#7B61FF] animate-pulse" />
              </div>
            </div>

            {/* <div className="relative">
              <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <Loader className="w-8 h-8 text-blue-500 animate-pulse" />
              </div>
            </div> */}
            <span className="mt-4 text-gray-600">
              Checking for existing policies...
            </span>
          </div>
        </div>
      </div>
    );
  }

  // If error occurred
  if (error) {
    return (
      <div className="space-y-6 p-4">
        {/* {renderBackButton()} */}

        <div className="text-center space-y-4">
          <h1 className="text-2xl font-bold text-gray-900">
            Something Went Wrong
          </h1>
          <div className="flex items-center justify-center text-red-600">
            <AlertCircle className="w-6 h-6 mr-2" />
            <span>{error}</span>
          </div>
        </div>
        <Card>
          <CardContent className="pt-6">
            <button
              onClick={() => window.location.reload()}
              className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Try Again
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }
  // When policies are found
  // if (existingPolicies && existingPolicies.length > 0) {
  //   return (
  //     <div>
  //       <InsurancePoliciesView
  //         policies={existingPolicies}
  //         onReupload={(policy) => {
  //           // Logic to handle reupload
  //           // This could trigger the file upload modal or navigation
  //           onUpload(policy);
  //         }}
  //       />
  //       <div className="space-y-6 p-4">
  //         <button
  //           onClick={handleProceed}
  //           className={`w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient text-white px-4 py-3 rounded-[10px] hover:bg-purpleGradientDark transition-colors`}
  //         >
  //           <span>Next</span>
  //         </button>
  //         <button
  //           onClick={onBack}
  //           className="w-full uppercase h-12 border-2 border-darkGrey font-bold text-darkGrey px-4 rounded-xl transition-colors !mt-4"
  //         >
  //           Back
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }
  console.log("existingPolicy", existingPolicy);
  // If existing policy is found
  if (existingPolicy) {
    // Store policy data in session storage for ReviewSubmitScreen to detect
    sessionStorage.setItem(
      "documentData",
      JSON.stringify({
        policyId: existingPolicy.id,
        provider: existingPolicy.provider,
        policyType: policyType, // 'manual' or 'connected'
        timestamp: existingPolicy.checkedInAt,
        fromServer: true, // Flag to indicate this came from server
      })
    );
    return (
      <div className="space-y-6 p-4">
        {/* {renderBackButton()} */}

        <div className="text-center space-y-4">
          <h1 className="text-2xl font-bold text-gray-900">
            Insurance Policy Found
          </h1>
          <p className="text-gray-600">
            We already have your insurance information on file
          </p>
        </div>

        <Card className="bg-green-50 border-green-100">
          <CardContent className="pt-6">
            <div className="flex items-start gap-3">
              <Check className="w-5 h-5 text-green-500 mt-1" />
              <div>
                <p className="font-medium text-green-900">
                  {policyType === "manual"
                    ? "Policy Document Uploaded"
                    : "Insurance Provider Connected"}
                </p>
                <p className="text-sm text-green-700 mt-1">
                  {existingPolicy.provider &&
                    `Provider: ${existingPolicy.provider}`}
                  {existingPolicy.policyNumber &&
                    `, Policy #: ${existingPolicy.policyNumber
                      .slice(-4)
                      .padStart(existingPolicy.policyNumber.length, "*")}`}
                </p>
                <p className="text-xs text-green-700 mt-1">
                  {policyType === "manual"
                    ? `Uploaded on ${new Date(
                        existingPolicy.checkedInAt
                      ).toLocaleDateString()}`
                    : `Connected on ${new Date(
                        existingPolicy.checkedInAt
                      ).toLocaleDateString()}`}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <button
          onClick={handleProceed}
          className={`w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient text-white px-4 py-3 rounded-[10px] hover:bg-purpleGradientDark transition-colors`}
        >
          <span>Next</span>
        </button>
        <button
          onClick={onBack}
          className="w-full uppercase h-12 border-2 border-darkGrey font-bold text-darkGrey px-4 rounded-xl transition-colors !mt-4"
        >
          Back
        </button>

        {/* <Card>
          <CardContent className="pt-6">
            <button
              onClick={handleProceed}
              className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Continue
              <ArrowRight className="w-4 h-4" />
            </button>
          </CardContent>
        </Card> */}

        <div className="space-y-2">
          {/* <p className="text-sm text-center text-gray-600">Need to update your policy?</p>
          <div className="flex justify-center space-x-4">
            <button 
              onClick={onUpload}
              className="text-blue-600 text-sm hover:text-blue-800"
            >
              Upload New Document
            </button>
            <button 
              onClick={onSync}
              className="text-blue-600 text-sm hover:text-blue-800"
            >
              Connect Provider
            </button>
          </div> */}
        </div>
      </div>
    );
  }

  // Default view - no existing policy
  return (
    <div className="space-y-6 p-4">
      {/* {renderBackButton()} */}

      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-xl uppercase font-bold text-gray-900">
          Upload Your Insurance Declaration
        </h1>
        <p className="text-gray-600">
          This helps us verify your profile so you can start earning. You can
          either upload it or sync it securely with Canopy
        </p>
      </div>

      {/* Upload Option */}
      <Card
        className="cursor-pointer border border-gray-300 hover:border-indigo-200 transition-colors shadow-none rounded-[10px]"
        onClick={onUpload}
      >
        <CardContent className="px-3 py-5">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center">
              <Upload className="w-5 h-5 text-blue-500" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-900">Upload a PDF</h3>
              <p className="text-sm text-gray-600 mt-1">
                Manually upload your insurance policy PDF
              </p>
            </div>
            {/* <ArrowRight className="w-5 h-5 text-gray-400" /> */}
          </div>
        </CardContent>
      </Card>

      <div className="flex justify-center !mb-10">
        <a
          onClick={() => setOpenPreviewModal(true)}
          className="underline text-[#1B1B1E]"
        >
          See a sample
        </a>
      </div>

      <DocumentPreviewModal
        open={openPreviewModal}
        onOpenChange={setOpenPreviewModal}
      />

      {/* Sync Option */}
      {/* <Card
        className="cursor-pointer hover:border-blue-200 transition-colors"
        onClick={onSync}
      >
        <CardContent className="px-3 py-5">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center">
              <Link className="w-5 h-5 text-green-500" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-900">
                Sync with Canopy Connect
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                Securely connect with your insurance provider
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400" />
          </div>
        </CardContent>
      </Card> */}

      <div className="flex flex-col">
        <button
          onClick={handleProceed}
          disabled={loading || !existingPolicy}
          className={`w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient text-white px-4 py-3 rounded-[10px] hover:bg-purpleGradientDark transition-colors disabled:bg-none disabled:bg-gray-300`}
        >
          {loading ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Submitting...</span>
            </>
          ) : (
            <>
              {/* <span>{isReadOnly ? "Continue" : "Complete"}</span> */}
              <span>Submit</span>
              {/* <ArrowRight className="w-4 h-4" /> */}
            </>
          )}
        </button>
        <button
          onClick={onBack}
          className="w-full uppercase h-12 border-2 border-darkGrey font-bold text-darkGrey px-4 rounded-xl transition-colors mt-4"
        >
          Back
        </button>
      </div>

      {/* <p className="text-xs text-center text-gray-500">
        Your data is encrypted and securely transmitted using bank-level
        security
      </p> */}
    </div>
  );
};

export default InsurancePolicyUploader;
